// Grade Finder recommendation logic — edit here to change how grades are matched.
// Steps: application -> target colour -> process preference ("Natural" | "Alkalized" | "None").

export const FINDER_APPLICATIONS = ["Bakery", "Beverages", "Confectionery", "Dairy", "Ice Cream", "Chocolate Coatings"];
export const FINDER_COLOURS = ["Light Brown", "Brown", "Dark Brown", "Black"];

export function recommendGrades(products, application, colour, preference) {
  const colourPool = products.filter(
    (p) => p.color === colour && (p.applications || []).includes(application)
  );
  let matches = preference === "None" ? colourPool : colourPool.filter((p) => p.type === preference);
  let relaxed = false;
  if (matches.length === 0 && preference !== "None") {
    matches = colourPool;
    relaxed = true;
  }
  if (matches.length === 0) {
    matches = products.filter((p) => (p.applications || []).includes(application));
    relaxed = true;
  }
  return { results: matches.slice(0, 2), relaxed };
}
